import local$ from 'jquery';
import 'slick-carousel';

global.$ = global.$ || local$;
const { Rollbar } = global;
const { ytPlayer } = global;

function singleVideoIframe(element) {
  const iframe = $('<iframe>');
  iframe.attr(
    'src',
    `//www.youtube.com/embed/${$(element).data(
      'video-id'
    )}?autoplay=1&autohide=2&border=0&wmode=opaque&enablejsapi=1&controls=0&showinfo=0&rel=0`
  );
  iframe.attr('frameborder', '0');
  iframe.addClass('youtube-iframe');
  $(element).empty();
  $(element).append(iframe);
}

function generateVideoIframes() {
  $.each($('.youtube-iframe-dialog'), function () {
    if ($(this).data('video-id')) {
      singleVideoIframe($(this));
    }
  });
}

$(document).ready(function () {
  try {
    // Home youtube scetion
    $('.ytvideo--cover_image').on('click', function () {
      $(this).parents('.videoWrapper').addClass('playing');
      ytPlayer.playVideo();
    });
    // End - Home youtube scetion

    $('#playImage').on('click', function () {
      $('.play-btn').hide();
      generateVideoIframes();
      // console.log('holis')
    });

    if (typeof $.fn.slick === 'function') {
      const introSlides = $('.intro__slider ul');
      if (introSlides) {
        introSlides.slick({
          slidesToShow: 1,
          arrows: false,
          autoplay: true,
          autoplaySpeed: 5000,
          dots: true,
        });
      }

      $('.product__slider ul').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        asNavFor: '.product__thumbs ul',
        arrows: false,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1,
              dots: true,
              // variableWidth: true,
            },
          },
        ],
      });

      $('.product__thumbs ul').slick({
        asNavFor: '.product__slider ul',
        slidesToShow: 4,
        slidesToScroll: 1,
        focusOnSelect: true,
        prevArrow:
          '<button type="button" class="slick-prev"><i class="fa fa-angle-left" aria-hidden="true"></i></button>',
        nextArrow:
          '<button type="button" class="slick-next"><i class="fa fa-angle-right" aria-hidden="true"></i></button>',
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
              dots: true,
            },
          },
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3,
            },
          },
        ],
      });

      $('.favourite__list').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        prevArrow:
          '<button type="button" class="slick-prev"><i class="fa fa-angle-left" aria-hidden="true"></i></button>',
        nextArrow:
          '<button type="button" class="slick-next"><i class="fa fa-angle-right" aria-hidden="true"></i></button>',
        responsive: [
          {
            breakpoint: 1300,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 980,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      });

      if ($(window).width() < 768) {
        $('.shopify-section .products--list').slick({
          prevArrow:
            '<button type="button" class="slick-prev"><i class="fa fa-angle-left" aria-hidden="true"></i></button>',
          nextArrow:
            '<button type="button" class="slick-next"><i class="fa fa-angle-right" aria-hidden="true"></i></button>',
          responsive: [
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1,
              },
            },
          ],
        });

        $('.related .products--list').slick({
          prevArrow:
            '<button type="button" class="slick-prev"><i class="fa fa-angle-left" aria-hidden="true"></i></button>',
          nextArrow:
            '<button type="button" class="slick-next"><i class="fa fa-angle-right" aria-hidden="true"></i></button>',
          responsive: [
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1,
              },
            },
          ],
        });
      }
    }
  } catch (e) {
    Rollbar.error('sliders js', e);
  }
});
